@if (!templateForPermitForm) {
<wm-workflow-test-as-client
  #testAsClientModal
  [workflowId]="workflowId"
  [versionId]="versionId"
  [applicationId]="applicationId"
  (onTest)="loadUsingTestClient()"
>
</wm-workflow-test-as-client>
} @else {
<app-test-workflow-modal
  *ngIf="showTestWorkflowModal"
  [isOpen]="showTestWorkflowModal"
  [showTestAsClient]="false"
  [workflowId]="workflowId"
  [versionId]="versionId"
  [clientId]="context?.client?.id"
  [applicationId]="applicationId"
  (onTest)="loadUsingTestClient()"
  (closed)="showTestWorkflowModal = false; testWorkflowModalShown = false"
>
</app-test-workflow-modal>
}

<div
  class="bmd-layout-container bmd-drawer-f-l"
  [ngClass]="{
    'bmd-drawer-overlay': isMobileDevice,
    'bmd-drawer-out': isMobileDevice && !menuOpen,
    'bmd-drawer-in': !isMobileDevice || menuOpen,
    'template-form': templateForPermitForm
  }"
>
  <header class="bmd-layout-header">
    <nav
      *ngIf="isMobileDevice"
      class="navbar navbar-expand-lg navbar-light bg-white"
    >
      <button
        *ngIf="isMobileDevice"
        (click)="menuOpen = !menuOpen"
        class="navbar-toggler mr-3"
        id="sidebar-toggler"
        type="button"
      >
        <span class="sr-only">Toggle drawer</span>
        <i class="material-icons">menu</i>
      </button>
      <a class="navbar-brand mr-auto" *ngIf="context?.client?.name">
        {{ context.client.name }}
      </a>
    </nav>
  </header>
  <div id="dw-app" class="bmd-layout-drawer bg-faded">
    <header>
      <a class="navbar-brand" *ngIf="context.client">
        <span *ngIf="!context.client.logoURL">{{ context.client.name }}</span>
        <img
          *ngIf="context.client.logoURL"
          [src]="context.client.logoURL"
          [alt]="context.client.name"
          style="max-height: 150px;"
          class="img-fluid"
        />
      </a>
      <div class="pt-3 pl-4">
        <!-- style="padding-left: 35px" -->
        <h4>{{ workflowName }}</h4>

        <h6 class="text-muted pb-3">
          <span class="float-left" style="width: 92%;">
            {{ applicationNumber }}
          </span>

          <span
            class="float-right"
            style="width: 8%"
            *ngIf="applicationNumber && canEditApplicationNumber"
          >
            <wm-edit-application-number
              linkText="Edit"
              [applicationId]="applicationId"
              [applicationNumber]="applicationNumber"
              [clientApplicationNumber]="clientApplicationNumber"
              (numberChanged)="applicationNumber = $event"
            ></wm-edit-application-number>
          </span>
        </h6>

        <wm-modal-confirm
          #newDocument
          commandText=""
          buttonText="View Summary"
          [showButtonText]="true"
          [showButton]="true"
          title="Summary"
          (opened)="retrieveSummary()"
          [buttonStyle]="buttonStyles.Button"
          *ngIf="(applicationNumber || '') !== ''"
        >
          <app-loader *ngIf="!summaryActivities"></app-loader>
          <a
            *ngIf="summaryActivities"
            [routerLink]="[
              '/application/workflow-application-print-summary',
              context.applicationId
            ]"
            target="_blank"
            >Printer Friendly</a
          >
          <div
            ngbDropdown
            class="d-inline-block float-right"
            *ngIf="canViewVersion"
          >
            <button
              class="btn btn-raised btn-primary"
              id="dropdownBasic1"
              ngbDropdownToggle
            >
              Actions
            </button>
            <div
              ngbDropdownMenu
              style="width: auto;"
              aria-labelledby="dropdownBasic1"
            >
              <a ngbDropdownItem (click)="openApplicationWorkflowBuilder()"
                >View Application Workflow</a
              >
            </div>
          </div>
          <wm-application-readonly
            *ngIf="summaryActivities"
            [applicationId]="context.applicationId"
            [activities]="summaryActivities"
            [isTestApplication]="isTestApplication"
          ></wm-application-readonly>
        </wm-modal-confirm>

        <wm-modal-confirm
          #requiredDocumentsModal
          commandText=""
          buttonText="Required Documents"
          [showButtonText]="true"
          [showButton]="true"
          title="Required Documents"
          [buttonStyle]="buttonStyles.Button"
          class="ml-2"
          *ngIf="context.isLocalEnvironment"
        >
          <wm-application-required-documents
            [applicationId]="context.applicationId"
          ></wm-application-required-documents>
        </wm-modal-confirm>

        <wm-modal-confirm
          #newDocument
          [commandText]="canEditNotes ? 'Save' : null"
          buttonText="Notes"
          [showButtonText]="true"
          [showButton]="true"
          title="Notes"
          (opened)="retrieveApplication().subscribe()"
          (accepted)="saveNotes()"
          [buttonStyle]="buttonStyles.Button"
          *ngIf="applicationNumber"
          class="ml-2"
        >
          <app-loader *ngIf="!application"></app-loader>
          <ng-container *ngIf="application">
            <ul
              ngbNav
              #modalNotes="ngbNav"
              [destroyOnHide]="false"
              class="nav-tabs"
            >
              <li ngbNavItem="modalExternalNotes">
                <a ngbNavLink>External Notes</a>
                <ng-template ngbNavContent>
                  <wm-application-external-note-editor
                    [application]="application"
                  ></wm-application-external-note-editor>
                </ng-template>
              </li>
              <li ngbNavItem="modalInternalNotes" *ngIf="canEditNotes">
                <a ngbNavLink>Internal Notes</a>
                <ng-template ngbNavContent>
                  <ng-container *ngIf="canEditNotes">
                    <wm-application-internal-note-editor
                      [application]="application"
                    ></wm-application-internal-note-editor>
                  </ng-container>
                </ng-template>
              </li>
              <!-- Condition added by Sanchit on 09/24/2026 -->
              @if (templateForPermitForm) {
              <li ngbNavItem="modalApplicationNotes">
                <a ngbNavLink>Application Notes</a>
                <ng-template ngbNavContent>
                  <app-workflow-application-notes
                    [applicationId]="context.applicationId"
                  ></app-workflow-application-notes>
                </ng-template>
              </li>
              }
            </ul>
            <div [ngbNavOutlet]="modalNotes"></div>
          </ng-container>
        </wm-modal-confirm>
        <!-- <p>
        </p> -->
      </div>
    </header>

    <!-- Added by Amisha on 2026-06-12. -->
    <!-- Reason: route Janus stepper clicks through AppView confirmation logic before activity changes. -->
    <wm-workflow-application-navigation
      *ngIf="navigationItems"
      [currentActivity]="activity"
      [navigationItems]="navigationItems"
      [applicationId]="context.applicationId"
      (onNavigate)="requestStepNavigation($event)"
      (switchApplication)="loadApplication($event)"
      class="mb-auto sidebar-child"
    ></wm-workflow-application-navigation>

    <wm-workflow-application-fee-summary
      *ngIf="hasFees && fees"
      [currentActivity]="activity"
      [applicationId]="context.applicationId"
      class="sidebar-child"
      [fees]="fees"
    ></wm-workflow-application-fee-summary>
  </div>
  <main
    class="bmd-layout-content"
    *ngIf="!templateForPermitForm"
    style="position: fixed; top: 0;bottom: 60px; right: 0;left:0"
    (click)="mainClick()"
    [ngClass]="{
      'overlay-bg': menuOpen && isMobileDevice,
      'mobile-top-margin': isMobileDevice
    }"
  >
    <div class="container-fluid px-4">
      <wm-application-input
        [isNewLayout]="templateForPermitForm"
        (onActivityChanged)="changeActivity($event)"
        (onIsCompleteChanged)="isLastActivity = $event"
        (onShowNextChanged)="canUseNextChanged($event)"
        (onShowPreviousChanged)="canUsePrevious = $event"
        (onShowSaveChanged)="canUseSave = $event"
        (onNavigationChanged)="navigationItems = $event"
        (onFeesChanged)="fees = $event"
        (onHasFeesChanged)="hasFees = $event"
        (switchApplication)="loadApplication($event)"
        (save)="childSaved()"
        [applicationId]="applicationId"
        [workflowId]="workflowId"
        (CanVoidDiscardChanged)="canVoidChanged($event)"
        [isTestApplication]="isTestApplication"
        (applicationIsProcessing)="changeButtonAvailability($event)"
        (loadApplication)="loadApplication(applicationId)"
        [shouldShowSave]="shouldShowSave"
        [isLastActivity]="isLastActivity"
      ></wm-application-input>
    </div>
  </main>
</div>

<!-- Added by Amisha on 2026-08-25. -->
<!-- Reason: render the legacy footer only for non-Janus applications. -->
<nav
  id="bottom-nav"
  *ngIf="!templateForPermitForm"
  [ngClass]="{
    'template-form': templateForPermitForm,
    'navbar fixed-bottom navbar-expand-lg navbar-light bg-white': !templateForPermitForm
  }"
>
  <div class="container-fluid">
    <!-- left buttons -->
    <form class="form-inline">
      <button
        class="btn btn-raised mx-2 btn-primary"
        type="button"
        *ngIf="shouldShowPrevious"
        (click)="previous()"
        [disabled]="!canUsePrevious || applicationProcessing"
      >
        <span *ngIf="!isMobileDevice">Back</span>
        <i class="material-icons" *ngIf="isMobileDevice">
          arrow_back
        </i>
      </button>
      <div *ngIf="shouldShowCancel">
        <wm-modal-confirm
          *ngIf="!loadingDiscard"
          moduleId="cancel_application"
          [btnIcon]="isMobileDevice ? 'delete' : undefined"
          [buttonText]="isMobileDevice ? undefined : 'Discard'"
          btnColor="danger"
          [showButtonText]="true"
          [title]="'Discard Application'"
          [commandText]="'Discard Application'"
          (accepted)="cancel()"
          [enabled]="
            !isTestApplication && canUseCancelDiscard && !applicationProcessing
          "
        >
          <p>Are you sure you want to cancel this application?</p>

          <p>Canceling this application will do the following:</p>
          <ul>
            <li>
              Discard all data entered for this application and require you to
              start over.
            </li>
          </ul>
        </wm-modal-confirm>

        <button
          *ngIf="loadingDiscard"
          class="btn btn-raised btn-danger"
          disabled
        >
          <span
            class="spinner-border spinner-border-sm"
            role="status"
            aria-hidden="true"
          ></span>

          <span *ngIf="!isMobileDevice"> Loading...</span>
        </button>
      </div>

      <!-- Added by Amisha on 2026-08-25. -->
      <!-- Reason: restore the original Bootstrap Void dropdown for the non-Janus footer. -->
      <div
        ngbDropdown
        *ngIf="shouldShowVoid"
        class="mx-2 ml-2"
        placement="top-right"
      >
        <button
          class="btn btn-raised btn-danger"
          id="voidDropdownMenuButton"
          ngbDropdownToggle
          [disabled]="
            !appInputLoaded ||
            isTestApplication ||
            !canUseCancelDiscard ||
            applicationProcessing
          "
        >
          <i class="material-icons" *ngIf="isMobileDevice">
            delete
          </i>
          <span *ngIf="!isMobileDevice">
            Void
          </span>
        </button>
        <div ngbDropdownMenu aria-labelledby="voidDropdownMenuButton">
          <button ngbDropdownItem (click)="withdrawApplication()">
            Withdraw
          </button>
          <button ngbDropdownItem (click)="lockApplication()">Lock</button>
          <button ngbDropdownItem (click)="expireApplication()">Expire</button>
          <button ngbDropdownItem (click)="voidApplication()">Void</button>
        </div>
      </div>
    </form>

    <!-- center buttons -->
    <form class="form-inline ml-auto" *ngIf="isTestApplication">
      <label for="viewAsRole" class="bmd-label-floating">
        Role
      </label>
      <select
        class="form-control mx-2"
        [(ngModel)]="selectedRole"
        (change)="changeRole($event)"
        *ngIf="testRoles"
        name="viewAsRole"
      >
        <option *ngFor="let role of testRoles" [value]="role.id">
          {{ role.name }}
        </option>
      </select>

      <button
        class="btn btn-raised mx-2 btn-danger"
        type="button"
        (click)="exitTestApplication()"
        [disabled]="loadingExit || applicationProcessing"
      >
        <span *ngIf="!loadingExit">Exit Test</span>

        <span *ngIf="loadingExit">
          <span
            class="spinner-border spinner-border-sm"
            role="status"
            aria-hidden="true"
          ></span>
          Loading...
        </span>
      </button>
    </form>

    <!-- right buttons -->
    <form class="form-inline ml-auto">
      <!-- updated by furkan for fixing save & exit menu panel size -->
      <div
        ngbDropdown
        display="dynamic"
        placement="top-right"
        class="d-inline-block mx-2"
        *ngIf="shouldShowSave"
        #oldSaveWrap
        (openChange)="setDynamicMenuWidth(oldSaveWrap, 'oldSave')"
      >
        <button
          class="btn btn-raised btn-success"
          id="dropdownMenuButton"
          ngbDropdownToggle
          [disabled]="
            !canUseSave ||
            loadingSave ||
            applicationProcessing ||
            !appInputLoaded
          "
        >
          <i class="material-icons" *ngIf="isMobileDevice && !loadingSave">
            {{ activity && activity.canEdit ? 'save' : 'exit' }}
          </i>
          <span
            *ngIf="loadingSave"
            class="spinner-border spinner-border-sm"
            role="status"
            aria-hidden="true"
          ></span>

          <span *ngIf="!isMobileDevice && !loadingSave">
            {{ activity && activity.canEdit ? 'Save & Exit' : 'Exit' }}
          </span>
          <span *ngIf="!isMobileDevice && loadingSave">
            Loading...
          </span>
        </button>
        <!-- updated by furkan for fixing save & exit menu panel size -->
        <div
          ngbDropdownMenu
          aria-labelledby="dropdownMenuButton"
          [style.width.px]="menuWidths['oldSave']"
        >
          <button ngbDropdownItem (click)="save(false)">Save</button>
          <button ngbDropdownItem (click)="save(true)">
            Save & Exit
          </button>
        </div>
      </div>
      <button
        class="btn btn-raised btn-success"
        [disabled]="processing || applicationProcessing"
        *ngIf="!shouldShowSave"
        (click)="navigateToReferrer()"
      >
        Exit
      </button>

      <button
        class="btn btn-raised mx-2 btn-primary"
        type="button"
        *ngIf="shouldShowNext && activity?.type !== 'wait-activity'"
        (click)="next()"
        [disabled]="!canUseNext || applicationProcessing || !appInputLoaded"
      >
        <i class="material-icons" *ngIf="isMobileDevice">
          arrow_forward
        </i>
        <span *ngIf="!isMobileDevice">
           {{ processButtonLabel | titlecase }}
        </span>
      </button>
    </form>
  </div>
</nav>

<!-- Added by priya 2025-11-04 -->
<!-- Template for Apply for permit forms integrating the existing component -->
<!--    added by priya 2025-11-04
 -->
<!-- Laptop and tablet view  -->
<!-- Added by Amisha on 2026-09-29.
     Reason: identify the shared App View shell used by staff mobile inline and overlay scroll containment. -->
<div
  class="app-view-shell"
  [ngClass]="{
    'new-applications-main-container': applyOverlayStyleToAppView(),
    'overlay-form': context.janusLayout === 'applicant' && isMyApplicationsRoute
  }"
  [style.padding-bottom]="showBottomPadding ? '24px' : null"
  [style.position]="showPosition ? 'static' : null"
>
  <!-- added by priya 19-02-2026 -->

  <div class="panel">
    <router-outlet></router-outlet>
  </div>

  <!-- end by priya 19-02-2026 -->
  <!-- Unified container: single wm-application-input shared by desktop + mobile.
       Form state survives viewport changes; ng-touched applies to the visible
       form because there is only one form instance. -->
  <div class="mobile-launch-content hide-on-desktop">
    @if(context?.isJanusChildWorkflowCalled === true &&
    callWorkflowsParentApplicationList &&
    callWorkflowsParentApplicationList.length > 0){

    <div class="mobile-header-title-container hide-on-desktop">
      @for (pw of callWorkflowsParentApplicationList; track $index) {
      <div class="header-underline">
        <wm-common-text
          (click)="onJanusParentWorkflowApplicationClick(pw.applicationId)"
          [data]="{ text: pw.activityLabel }"
          class="mobile-header-parent-title"
        ></wm-common-text>
        <wm-common-text
          [data]="{ text: ' App ' + pw.applicationNumber }"
          class="mobile-header-parent-title"
        ></wm-common-text>
      </div>
      <wm-common-text [data]="{ text: '>' }"></wm-common-text>
      }
      <wm-common-text
        [data]="{ text: workflowName }"
        class="mobile-header-child-title"
      ></wm-common-text>
      <wm-common-text
        [data]="{ text: 'App ' + applicationNumber }"
        class="mobile-header-child-title"
      ></wm-common-text>
    </div>
    }
    <div
      class="info-container"
      *ngIf="
        context?.isJanusChildWorkflowCalled === true &&
        callWorkflowsParentApplicationList &&
        callWorkflowsParentApplicationList.length > 0
      "
    >
      <wm-common-icon
        [data]="{ iconName: infoIcon }"
        class="info-icon"
      ></wm-common-icon>
      <div class="info-content">
        <wm-common-text
          [data]="{ text: 'Required Application' }"
          class="info-content-header"
        ></wm-common-text>
        <wm-common-text
          [data]="{text:`You must complete this application as part of your ${callWorkflowsParentApplicationList?.[0]?.activityLabel} application`}"
          class="info-content-text"
        >
        </wm-common-text>
      </div>
    </div>
  </div>
  <div
    #activityTop
    class="main-stepper-container"
    *ngIf="templateForPermitForm"
  >
    @if(loading){
    <div class="skeleton skeleton-text"></div>
    }@else{

    <!-- Desktop header (hidden on mobile via CSS) -->
    <div
      class="header-container hide-on-mobile"
      [class.child-workflow-header-container]="
        context?.isJanusChildWorkflowCalled === true &&
        callWorkflowsParentApplicationList &&
        callWorkflowsParentApplicationList.length > 0
      "
    >
      <!-- added by furkan 17-04-2026 -->
      @if(context?.isJanusChildWorkflowCalled === true &&
      callWorkflowsParentApplicationList &&
      callWorkflowsParentApplicationList.length > 0){
      <div
        class="title-wrapper"
        style="display: flex;justify-content: flex-start;align-items: center;column-gap: 5px;flex-direction: row;"
      >
        @for (pw of callWorkflowsParentApplicationList; track $index) {
        <div class="parent-workflow-tile ">
          <div class="janus-cursor-pointer worflow-title-underline">
            <wm-common-text
              (click)="onJanusParentWorkflowApplicationClick(pw.applicationId)"
              [data]="{ text: pw.activityLabel }"
            ></wm-common-text>
            <wm-common-text
              [data]="{ text: ' Application ' + pw.applicationNumber }"
            ></wm-common-text>
          </div>
          <wm-common-text [data]="{ text: '>' }"></wm-common-text>
        </div>
        }
        <div class="parent-workflow-tile active-child-worflow">
          <wm-common-text [data]="{ text: workflowName }"></wm-common-text>
          <wm-common-text
            [data]="{ text: 'Application ' + applicationNumber }"
          ></wm-common-text>
        </div>
      </div>
      }@else {
      <div class="title-wrapper">
        <div class="title-content">
          <wm-common-text
            [data]="{ text: workflowName }"
            class="header"
          ></wm-common-text>
          <ng-container *ngIf="applicationNumber">
            <span class="title-separator">|</span>
            <wm-common-text
              [data]="{ text: 'Application # ' + applicationNumber }"
              class="header"
            ></wm-common-text>
          </ng-container>
        </div>
      </div>
      }
      <div class="role-estimate-content">
        <app-common-estimate-total-fee
          *ngIf="hasFees && fees"
          [currentActivity]="activity"
          [applicationId]="context.applicationId"
          class="sidebar-child"
          [fees]="fees"
        >
        </app-common-estimate-total-fee>
        <div class="role-delete-content">
          <div class="role-container" *ngIf="isTestApplication">
            <wm-common-text
              [data]="{ text: 'Role' }"
              class="role-text"
              [class.role-selected]="selectedRole"
            ></wm-common-text>
            <div
              class="selected-janus-value"
              [class.role-selected]="getSelectedRoleName() !== ''"
              (click)="toggleRoleMenu($event)"
            >
              {{ getSelectedRoleName() || 'Select Role' }}
              <span class="material-icons dropdown-icon">
                keyboard_arrow_down
              </span>
              <div *ngIf="openRoleMenu" class="nested-menu-options">
                <div class="menu-items-container">
                  <div
                    class="menu-item"
                    *ngFor="let role of testRoles"
                    [class.active]="selectedRole === role.id"
                    (click)="onRoleSelect(role); $event.stopPropagation()"
                  >
                    {{ role.name }}
                  </div>
                </div>
                <wm-common-button
                  class="exit-test-button"
                  [data]="{
                    text: 'Exit Test',
                    disabled: loadingExit || applicationProcessing
                  }"
                  (click)="exitTestApplication(); $event.stopPropagation()"
                >
                  <ng-container *ngIf="!loadingExit">
                    Exit Test
                  </ng-container>

                  <ng-container *ngIf="loadingExit">
                    <span class="spinner-border spinner-border-sm"></span>
                    Loading...
                  </ng-container>
                </wm-common-button>
              </div>
            </div>
          </div>

          <!-- ended by furkan 17-04-2026 -->
          @if(showCloseIcon){
          <div
            [class.child-workflow-header-close]="
              context?.isJanusChildWorkflowCalled === true &&
              callWorkflowsParentApplicationList &&
              callWorkflowsParentApplicationList.length > 0
            "
          >
            <wm-common-icon
              [data]="{ iconName: closeSvgIcon }"
              (click)="onCloseIconClick()"
              class="close-icon-janus"
            ></wm-common-icon>
          </div>
          }
        </div>
      </div>
    </div>

    <!-- Added by Amisha on 09-06-2026 to show a mobile-only back arrow for Janus app view
         and keep the workflow title on the next line like summary view. -->

    <div class="mobile-header hide-on-desktop">
      <div class="close-role-content">
        <wm-common-icon
          *ngIf="context?.janusLayout === 'staff'"
          class="menu-icon staff-menu-icon"
          [data]="{ iconName: svgs.hamburgerIcon.name }"
          (click)="toggleStaffStepper()"
          style="cursor: pointer; margin-left: 12px; margin-right: 8px; display: flex; align-items: center;"
        ></wm-common-icon>

        <button
          *ngIf="showCloseIcon && context?.janusLayout"
          type="button"
          class="mobile-close-arrow"
          aria-label="Close application view"
          (click)="openModal()"
        >
          <mat-icon>arrow_back</mat-icon>
        </button>
        <div class="role-content">
          <div class="role-container" *ngIf="isTestApplication">
            <wm-common-text
              [data]="{ text: 'Role' }"
              class="role-text"
              [class.role-selected]="selectedRole"
            ></wm-common-text>
            <div
              class="selected-janus-value"
              [class.role-selected]="getSelectedRoleName() !== ''"
              (click)="toggleRoleMenu($event)"
            >
              {{ getSelectedRoleName() || 'Select Role' }}
              <span class="material-icons dropdown-icon">
                keyboard_arrow_down
              </span>
              <div *ngIf="openRoleMenu" class="nested-menu-options">
                <div class="menu-items-container">
                  <div
                    class="menu-item"
                    *ngFor="let role of testRoles"
                    [class.active]="selectedRole === role.id"
                    (click)="onRoleSelect(role); $event.stopPropagation()"
                  >
                    {{ role.name }}
                  </div>
                </div>
                <wm-common-button
                  class="exit-test-button"
                  [data]="{
                    text: 'Exit Test',
                    disabled: loadingExit || applicationProcessing
                  }"
                  (click)="exitTestApplication(); $event.stopPropagation()"
                >
                  <ng-container *ngIf="!loadingExit">
                    Exit Test
                  </ng-container>

                  <ng-container *ngIf="loadingExit">
                    <span class="spinner-border spinner-border-sm"></span>
                    Loading...
                  </ng-container>
                </wm-common-button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- added by furkan 28-04-2026 -->
      <div
        class="title-wrapper mobile-title-wrapper mobile-header-trigger"
        (click)="toggleStepperModal()"
      >
        <wm-common-text
          [data]="{ text: workflowName }"
          class="mobile-header-title"
        ></wm-common-text>
        <ng-container *ngIf="applicationNumber">
          <span class="title-separator mobile-separator">|</span>
          <wm-common-text
            [data]="{ text: 'Application # ' + applicationNumber }"
            class="mobile-app-number"
          ></wm-common-text>
        </ng-container>
        <app-common-estimate-total-fee
          *ngIf="hasFees && fees"
          [currentActivity]="activity"
          [applicationId]="context.applicationId"
          class="sidebar-child"
          [fees]="fees"
        >
        </app-common-estimate-total-fee>
      </div>
      <!-- ended by furkan 28-04-2026 -->
    </div>

    <wm-common-confirmation-modal
      #closeModal
      [data]="closeModalData"
      (onNoClick)="onCloseModal()"
      (onYesClick)="closeApplication()"
      [isApplicantMobileview]="true"
    ></wm-common-confirmation-modal>
    <!-- Start Code added by Sanchit on 12/06/2026 -->
    <wm-common-confirmation-modal
      [data]="browserBackModalData"
      (onNoClick)="closeBrowserBackModal()"
      (onYesClick)="leavePageFromBrowserBack()"
      [isApplicantMobileview]="true"
    >
    </wm-common-confirmation-modal>
    <!-- End Code added by Sanchit on 12/06/2026 -->
    }

    <ng-container *ngIf="isMobileDevice">
      <div
        class="drawer-overlay"
        *ngIf="isStepperOpen"
        (click)="isStepperOpen = false"
      ></div>
      <div class="stepper-modal" *ngIf="isStepperOpen">
        <div class="stepper-content">
          <wm-common-button
            *ngIf="isMyApplicationsRoute"
            class="view-summary-button"
            [data]="{text:'View Summary',onClick:openApplicationSummary.bind(this)}"
          ></wm-common-button>
          <!-- Added by Amisha on 2026-06-12. -->
          <!-- Reason: keep the mobile Janus stepper on the same confirmation path as desktop. -->
          <!-- <div class="info-container hide-on-mobile">
            <wm-common-icon [data]="{iconName:infoIcon}"></wm-common-icon>
            <wm-common-text [data]="{text:`You must complete this application as part of your  application ${callWorkflowsParentApplicationList[0].activityLabel} application`}">
            </wm-common-text>
          </div> -->
          <wm-workflow-application-navigation
            *ngIf="navigationItems"
            [currentActivity]="activity"
            [navigationItems]="navigationItems"
            [applicationId]="context?.applicationId"
            (onNavigate)="requestStepNavigation($event)"
            (switchApplication)="loadApplication($event)"
            (stepClicked)="scrollToTop()"
            class="mb-auto sidebar-child"
          ></wm-workflow-application-navigation>
        </div>
        <mat-icon class="close-icon" (click)="closeStepper()">close</mat-icon>
      </div>
    </ng-container>

    <div class="stepper-and-content-row">
      <!-- Desktop sidebar (hidden on mobile via CSS) -->
      <div class="stepper-sidebar hide-on-mobile">
        <div class="sidebar-child-stepper">
          @if(loading){
          <div class="skeleton-stepper-wrapper">
            <div class="skeleton-item" *ngFor="let s of skeletonArray"></div>
          </div>
          }@else{ @if (!(context.janusLayout==='staff' &&
          context.applicationViewType === 'overlay')) {
          <wm-common-button
            *ngIf="isMyApplicationsRoute"
            class="view-summary-button"
            [data]="{text:'View Summary',onClick:openApplicationSummary.bind(this)}"
          ></wm-common-button>
          }
          <!-- Added by Amisha on 2026-06-12. -->
          <!-- Reason: keep the Janus new-layout sidebar stepper on the same confirmation path. -->
          <wm-workflow-application-navigation
            *ngIf="navigationItems"
            [currentActivity]="activity"
            [navigationItems]="navigationItems"
            [applicationId]="context?.applicationId"
            (onNavigate)="requestStepNavigation($event)"
            (switchApplication)="loadApplication($event)"
            (stepClicked)="scrollToTop()"
            class="mb-auto sidebar-child"
          ></wm-workflow-application-navigation>
          }
        </div>
      </div>

      <!-- Single content area used by both desktop and mobile -->
      <div class="stepper-content">
        <div>
          @if(loading){
          <div class="skeleton skeleton-text"></div>
          <div class="skeleton stepper-skeleton-content"></div>
          <div class="skeleton stepper-skeleton-content2"></div>
          <div class="skeleton skeleton-title"></div>
          <div class="skeleton skeleton-textfield"></div>
          <div class="skeleton-wrapper">
            <div class="skeleton skeleton-textfield"></div>
            <div class="skeleton skeleton-textfield"></div>
            <div class="skeleton skeleton-textfield"></div>
          </div>
          <div class="skeleton-wrapper">
            <div class="skeleton skeleton-textfield"></div>
            <div class="skeleton skeleton-textfield"></div>
          </div>
          <div class="skeleton-wrapper">
            <div class="skeleton skeleton-textfield"></div>
            <div class="skeleton skeleton-textfield"></div>
          </div>

          <div class="skeleton-wrapper">
            <div class="skeleton skeleton-textfield"></div>
            <div class="skeleton skeleton-textfield"></div>
          </div>
          <div class="skeleton-wrapper">
            <div class="skeleton skeleton-textfield"></div>
            <div class="skeleton skeleton-textfield"></div>
          </div>
          <div class="skeleton skeleton-text"></div>
          <div class="skeleton skeleton-textfield"></div>

          <div class="skeleton-wrapper">
            <div class="skeleton skeleton-textfield"></div>
            <div class="skeleton skeleton-textfield"></div>
          </div>
          <div class="skeleton-wrapper">
            <div class="skeleton skeleton-textfield"></div>
            <div class="skeleton skeleton-textfield"></div>
            <div class="skeleton skeleton-textfield"></div>
          </div>
          }@else{
          <!-- The ONE and only wm-application-input. Lives here for the
               entire lifetime of templateForPermitForm. CSS handles which
               surrounding chrome (sidebar vs. drawer) is shown. -->
          <div
            class="info-container info-container-desktop hide-on-mobile"
            *ngIf="
              context?.isJanusChildWorkflowCalled === true &&
              callWorkflowsParentApplicationList &&
              callWorkflowsParentApplicationList.length > 0
            "
          >
            <wm-common-icon
              [data]="{ iconName: infoIcon }"
              class="info-icon info-icon-desktop"
            ></wm-common-icon>
            <wm-common-text
              [data]="{text:`You must complete this application as part of your  application ${callWorkflowsParentApplicationList?.[0]?.activityLabel} application`}"
              class="info-content-text info-content-text-desktop"
            >
            </wm-common-text>
          </div>
          <wm-application-input
            [isNewLayout]="templateForPermitForm"
            (onActivityChanged)="changeActivity($event)"
            (onIsCompleteChanged)="isLastActivity = $event"
            (onShowNextChanged)="canUseNextChanged($event)"
            (onShowPreviousChanged)="canUsePrevious = $event"
            (onShowSaveChanged)="canUseSave = $event"
            (onNavigationChanged)="navigationItems = $event"
            (onFeesChanged)="fees = $event"
            (onHasFeesChanged)="hasFees = $event"
            (switchApplication)="loadApplication($event)"
            (save)="childSaved()"
            [applicationId]="applicationId"
            [workflowId]="workflowId"
            (CanVoidDiscardChanged)="canVoidChanged($event)"
            [isTestApplication]="isTestApplication"
            (applicationIsProcessing)="changeButtonAvailability($event)"
            (loadApplication)="loadApplication(applicationId)"
            [shouldShowSave]="shouldShowSave"
            [isLastActivity]="isLastActivity"
            [activity]="activity"
          ></wm-application-input>
          }
        </div>
      </div>
    </div>
    <hr style="width:100%" />
    <ng-container *ngTemplateOutlet="wizardButtonsTemplate"></ng-container>
  </div>
</div>

<!-- Added by Amisha on 2026-08-25. -->
<!-- Reason: keep the legacy close-application modal available outside Janus-only containers. -->
<wm-modal-confirm
  moduleId="cancel_application"
  [showButton]="false"
  [title]="closeApplicationText + ' Application'"
  [commandText]="closeApplicationText + ' Application'"
  (accepted)="closeWorkflowApplication()"
  [form]="closeWorkflowApplicationForm"
  [janusStyling]="templateForPermitForm"
  janusModalWidth="620px"
  #closeApplicationModal
>
  <div [formGroup]="closeWorkflowApplicationForm">
    <div class="row">
      <div class="col">
        <label for="closeReason">{{ closeApplicationText }} Reason</label>
        <textarea
          style="height:100px"
          id="closeReason"
          name="closeReason"
          class="form-control mx-2"
          formControlName="closeReason"
          [placeholder]="closeApplicationText + ' Reason'"
          [attr.aria-label]="closeApplicationText + ' Reason'"
        >
        </textarea>
        <div *ngIf="closeReason.untouched" class="text-danger">
          * {{ closeApplicationText }} Reason is required.
        </div>
        <div
          *ngIf="
            closeReason.invalid && (closeReason.dirty || closeReason.touched)
          "
          class="alert alert-danger"
        >
          <div *ngIf="closeReason.errors['required']" class="text-danger">
            * {{ closeApplicationText }} Reason is required. *
          </div>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col">
        <label for="closeDateTime" class="mt-2">
          Time
          <input
            id="closeDateTime"
            name="closeDateTime"
            class="form-control mt-2"
            formControlName="closeDateTime"
            placeholder=""
            aria-label="DateTime"
          />
        </label>
      </div>
    </div>
    <div class="row">
      <div class="col">
        <label class="mt-2">
          Changed By
          <input
            name="closedBy"
            class="form-control mt-2"
            formControlName="closedBy"
            placeholder=""
            aria-label="ClosedBy"
          />
        </label>
      </div>
    </div>
  </div>

  <p>
    Any inspections currently in progress will be marked as Voided, and will not
    be visible by default in inspection searches.
  </p>

  <p>
    Are you sure you want to {{ closeApplicationText.toLowerCase() }} this
    application?
  </p>

  <p>
    Are you sure you want to
    {{ closeApplicationText.toLowerCase() }} this application?
  </p>
</wm-modal-confirm>

<ng-template #wizardButtonsTemplate>
  <div class="wizard-buttons" #wizardButtons *ngIf="templateForPermitForm">
    <div class="wizard"></div>

    <!-- Added by Amisha on 2026-08-31.
         Reason: mark secondary footer actions for Janus-only collapse at the existing <=394px stacked breakpoint. -->
    <div
      class="button-content"
      [class.janus-mobile-button-content]="isJanusMobileView"
      (click)="$event.stopPropagation()"
    >
      <div
        class="button-container"
        [class.janus-mobile-actions]="isJanusMobileView"
        [class.mobile-actions-open]="mobileActionsOpen"
      >
        @if(loading){
        <div class="skeleton skeleton-button mobile-collapsible-action"></div>
        }@else{
        <wm-common-button
          [data]="{text:'BACK',onClick:onBackClick.bind(this),disabled: applicationProcessing}"
          class="back-button mobile-collapsible-action"
        ></wm-common-button>
        <wm-common-confirmation-modal
          #backModal
          [data]="backModalData"
          (onNoClick)="onCloseBackModal()"
          (onYesClick)="backApplication()"
          [isApplicantMobileview]="
            context?.janusLayout === 'applicant' ? true : false
          "
          [isApplicantMobileview]="true"
        ></wm-common-confirmation-modal>

        }
        <!-- <button>Discard</button> -->
        <!-- CANCEL / DISCARD SECTION -->
        <div *ngIf="shouldShowCancel" class="discard-action">
          <!-- Discard Button -->
          @if(loading){
          <div class="skeleton skeleton-button mobile-collapsible-action"></div>
          }@else{
          <wm-common-button
            *ngIf="!loadingDiscard"
            [data]="{
              text: 'DISCARD',
              onClick: openCancelModal,
              disabled:
                isTestApplication ||
                !canUseCancelDiscard ||
                applicationProcessing
            }"
            class="discard-button mobile-collapsible-action"
          ></wm-common-button>
          }
          <!-- Loading Spinner Button -->
          <wm-common-button
            *ngIf="loadingDiscard"
            class="mobile-collapsible-action"
            [data]="{
              text: 'Loading...',
              disabled: true
            }"
          >
            <span
              class="spinner-border spinner-border-sm"
              role="status"
              aria-hidden="true"
            ></span>
          </wm-common-button>

          <!-- Keep modal confirm same -->
          <!-- <wm-modal-confirm
          #cancelModal
          moduleId="cancel_application"
          [showButton]="false"
          [title]="'Discard Application'"
          [commandText]="'Discard Application'"
          (accepted)="cancel()"
          [enabled]="
            !isTestApplication &&
            canUseCancelDiscard &&
            !applicationProcessing
          "
        >
          <p>Are you sure you want to cancel this application?</p>
          <p>Canceling this application will do the following:</p>
          <ul>
            <li>
              Discard all data entered for this application and require you to
              start over.
            </li>
          </ul>
        </wm-modal-confirm> -->
          <wm-common-confirmation-modal
            #cancelModal
            [data]="cancelModalData"
            (onNoClick)="closeCancelModal()"
            (onYesClick)="discardApplication()"
            [isApplicantMobileview]="
              context?.janusLayout === 'applicant' ? true : false
            "
            [isApplicantMobileview]="true"
          ></wm-common-confirmation-modal>
        </div>

        <!-- VOID SECTION -->
        <!-- updated by furkan for fixing save & exit menu panel size -->
        <div *ngIf="shouldShowVoid" class="mx-2 ml-2 void-button">
          <!-- template for button content -->
          <ng-template #voidIconTemplate>
            <div class="void-label">
              VOID
              <wm-common-icon [data]="{ iconName: svgs.arrowDropUpIcon.name }">
              </wm-common-icon>
            </div>
          </ng-template>

          <!-- code edited by Krutika for void  -->
          <div #newVoidWrap class="dynamic-save-wrap mobile-collapsible-action">
            <!-- actual button -->
            <wm-common-button
              class="navigate-button"
              [data]="{
                text: voidIconTemplate,
                disabled:
                  !appInputLoaded ||
                  isTestApplication ||
                  !canUseCancelDiscard ||
                  applicationProcessing
              }"
              [matMenuTriggerFor]="voidMenu"
              (menuOpened)="setVoidMenuWidth(newVoidWrap)"
            >
            </wm-common-button>

            <!-- menu -->
            <!-- updated by furkan for fixing save & exit menu panel size -->
            <mat-menu
              #voidMenu="matMenu"
              yPosition="above"
              panelClass="dynamic-width-menu"
            >
              <!-- <div [style.width.px]="newVoidWrap?.offsetWidth" style="min-width: max-content;"> -->
              <div>
                <button mat-menu-item (click)="withdrawApplication()">
                  Withdraw
                </button>
                <button mat-menu-item (click)="lockApplication()">Lock</button>
                <button mat-menu-item (click)="expireApplication()">
                  Expire
                </button>
                <button mat-menu-item (click)="voidApplication()">Void</button>
              </div>
            </mat-menu>
          </div>
          <!-- </div> -->

          <!-- Existing material modal confirm for close -->

          <wm-common-confirmation-modal
            moduleId="cancel_application"
            [showButton]="false"
            [form]="closeWorkflowApplicationForm"
            [data]="confirmationModalData"
            (onYesClick)="closeWorkflowApplication()"
            (onNoClick)="confirmationModalData.open = false"
            #closeApplicationModal
            [isApplicantMobileview]="true"
          >
            <div [formGroup]="closeWorkflowApplicationForm">
              <div class="row">
                <div class="col">
                  <!-- <label for="closeReason"
                >{{ closeApplicationText }} Reason</label
              >
              <textarea
                style="height:100px"
                id="closeReason"
                name="closeReason"
                class="form-control mx-2"
                formControlName="closeReason"
                [placeholder]="closeApplicationText + ' Reason'"
                [attr.aria-label]="closeApplicationText + ' Reason'"
              >
              </textarea> -->
                  <wm-common-textfield
                    [data]="{
                      placeholder: closeApplicationText + ' Reason',
                      label: closeApplicationText + ' Reason'
                    }"
                    formControlName="closeReason"
                  >
                  </wm-common-textfield>
                  <div *ngIf="closeReason.untouched" class="text-danger">
                    * {{ closeApplicationText }} Reason is required.
                  </div>
                  <div
                    *ngIf="
                      closeReason.invalid &&
                      (closeReason.dirty || closeReason.touched)
                    "
                    class="alert alert-danger"
                  >
                    <div
                      *ngIf="closeReason.errors['required']"
                      class="text-danger"
                    >
                      * {{ closeApplicationText }} Reason is required. *
                    </div>
                  </div>
                </div>
              </div>
              <!-- Start Code added by Sanchit on 19/05/2026 -->
              <!-- <div class="row">
                <div class="col">
                  <label for="closeDateTime" class="mt-2">
                    Time
                    <input
                      id="closeDateTime"
                      name="closeDateTime"
                      class="form-control mt-2"
                      formControlName="closeDateTime"
                      placeholder=""
                      aria-label="DateTime"
                    />
                  </label>
                </div>
              </div>
              <div class="row">
                <div class="col">
                  <label class="mt-2">
                    Changed By
                    <input
                      name="closedBy"
                      class="form-control mt-2"
                      formControlName="closedBy"
                      placeholder=""
                      aria-label="ClosedBy"
                    />
                  </label>
                </div>
              </div> -->
              <div class="textfield-row">
                <wm-common-textfield
                  class="textfield-item"
                  [data]="{
                    label: 'Time',
                    placeholder: '',
                    type: 'text'
                  }"
                  formControlName="closeDateTime"
                >
                </wm-common-textfield>

                <wm-common-textfield
                  class="textfield-item"
                  [data]="{
                    label: 'Changed By',
                    placeholder: '',
                    type: 'text'
                  }"
                  formControlName="closedBy"
                >
                </wm-common-textfield>
              </div>
              <!-- End Code added by Sanchit on 19/05/2026 -->
            </div>

            <p>
              Any inspections currently in progress will be marked as Voided,
              and will not be visible by default in inspection searches.
            </p>

            <p>
              Are you sure you want to
              {{ closeApplicationText.toLowerCase() }} this application?
            </p>

            <!-- <p>
              Are you sure you want to
              {{ closeApplicationText.toLowerCase() }} this application?
            </p> -->
          </wm-common-confirmation-modal>
        </div>
        <!-- </div> -->

        <!-- <button mat-button>Discard</button>
     <button mat-button>Save & Exit</button>
     <button
       mat-button
       color="primary"
       (click)="nextStep()"
       [disabled]="currentStep === permitFormData.PermitForm.length - 1"
     >
       Next
     </button> -->
      </div>

      <!-- Added by Amisha on 2026-08-31.
           Reason: apply the same compact open/closed state to Save/Exit and Next/Submit. -->
      <div
        class="button-container"
        [class.janus-mobile-actions]="isJanusMobileView"
        [class.mobile-actions-open]="mobileActionsOpen"
      >
        <!-- updated by furkan for fixing save & exit menu panel size -->
        <div *ngIf="shouldShowSave" class="save-button-wrapper">
          @if(loading){
          <div class="skeleton skeleton-button mobile-collapsible-action"></div>
          }@else{
          <div #newSaveWrap class="dynamic-save-wrap mobile-collapsible-action">
            <wm-common-button
              id="dropdownMenuButton"
              class="save-button"
              [matMenuTriggerFor]="
                canUseSave &&
                !loadingSave &&
                !applicationProcessing &&
                appInputLoaded
                  ? saveMenu
                  : null
              "
              (menuOpened)="setDynamicMenuWidth(newSaveWrap, 'newSave')"
              [data]="{
                text:
                  activity && activity.canEdit
                    ? loadingSave
                      ? 'Loading...'
                      : isMobileSaveButton
                      ? 'SAVE'
                      : 'SAVE & EXIT'
                    : loadingSave
                    ? 'Loading...'
                    : 'EXIT',
                disabled:
                  !canUseSave ||
                  loadingSave ||
                  applicationProcessing ||
                  !appInputLoaded,
                onClick: onSaveClicked
              }"
            >
              <i class="material-icons" *ngIf="!loadingSave">
                {{ activity && activity.canEdit ? 'SAVE' : 'EXIT' }}
              </i>

              <span
                *ngIf="loadingSave"
                class="spinner-border spinner-border-sm"
                role="status"
                aria-hidden="true"
              ></span>

              <span *ngIf="!loadingSave">
                {{ activity && activity.canEdit ? 'SAVE & EXIT' : 'EXIT' }}
              </span>
            </wm-common-button>
            <!-- updated by furkan for fixing save & exit menu panel size -->
            <!-- Material Menu -->
            <mat-menu
              #saveMenu="matMenu"
              yPosition="above"
              panelClass="dynamic-width-menu"
            >
              <div [style.width.px]="menuWidths['newSave']">
                <button mat-menu-item (click)="saveOpenModal()">
                  SAVE
                </button>
                <button mat-menu-item (click)="saveAndExitOpenModal()">
                  SAVE & EXIT
                </button>
              </div>
            </mat-menu>
          </div>
          }
          <!-- <div ngbDropdownMenu aria-labelledby="dropdownMenuButton">
          <wm-common-button ngbDropdownItem class="menu-button"
            [data]="{text:'Save',onClick:saveOpenModal.bind(this)}"></wm-common-button>

          <wm-common-button ngbDropdownItem class="menu-button"
            [data]="{ text: ' Save & Exit', onClick: saveAndExitOpenModal }">
          </wm-common-button>
        </div> -->
          <wm-common-confirmation-modal
            #saveAndExitModal
            [data]="saveAndExitModalData"
            (onNoClick)="saveAndExitcloseModal()"
            (onYesClick)="handleSaveAndExit()"
            [isApplicantMobileview]="
              context?.janusLayout === 'applicant' ? true : false
            "
            [isApplicantMobileview]="true"
          ></wm-common-confirmation-modal>
          <wm-common-confirmation-modal
            #saveModal
            [data]="saveModalData"
            (onNoClick)="saveCloseModal()"
            (onYesClick)="saveConfirm()"
            [isApplicantMobileview]="
              context?.janusLayout === 'applicant' ? true : false
            "
            [isApplicantMobileview]="true"
          ></wm-common-confirmation-modal>
        </div>

        <wm-common-button
          *ngIf="!shouldShowSave"
          class="navigate-button mobile-collapsible-action"
          [data]="{text:'EXIT',    onClick: exitOpenModal.bind(this),
disabled:processing || applicationProcessing }"
        >
        </wm-common-button>
        <wm-common-confirmation-modal
          #exitModal
          [data]="exitModalData"
          (onNoClick)="exitcloseModal()"
          (onYesClick)="handleExit()"
          [isApplicantMobileview]="
            context?.janusLayout === 'applicant' ? true : false
          "
          [isApplicantMobileview]="true"
        ></wm-common-confirmation-modal>
        <!-- Added by Amisha on 2026-06-12. -->
        <!-- Reason: show the Janus-only leave warning when shell/sidebar/navbar navigation exits AppView. -->
        <wm-common-confirmation-modal
          *ngIf="
            context?.janusLayout === 'staff' ||
            context?.janusLayout === 'applicant'
          "
          [data]="routeLeaveModalData"
          (onNoClick)="cancelRouteLeave()"
          (onYesClick)="confirmRouteLeave()"
          [isApplicantMobileview]="
            context?.janusLayout === 'applicant' ? true : false
          "
        ></wm-common-confirmation-modal>

        @if(loading){
        <div class="skeleton skeleton-button next-action"></div>
        }@else{
        <!-- Process Button (Next/Submit/Update) - controlled by activity properties -->
        <wm-common-button
          *ngIf="
            shouldShowNext &&
            !isLastActivity &&
            activity?.type !== 'wait-activity'
          "
          class="next-button next-action"
          [data]="{
text: nextProcessing ? loaderTemplate : ((isJanusContractorRegistration && activity?.processButtonText?.toUpperCase()) || nextButtonLabel),
onClick: handleNextClick.bind(this),
disabled: !canUseNext || applicationProcessing || !appInputLoaded
}"
        >
        </wm-common-button>
        <ng-template #loaderTemplate>
          <mat-progress-spinner
            class="mat-white-spinner"
            diameter="20"
            mode="indeterminate"
          ></mat-progress-spinner>
        </ng-template>
        <wm-common-button
          *ngIf="
            shouldShowNext &&
            isLastActivity &&
            activity?.type !== 'wait-activity'
          "
          class="next-button next-action"
          [data]="{
text: 'SUBMIT',
onClick: submitOpenModal.bind(this),
disabled: !canUseNext || applicationProcessing || !appInputLoaded
}"
        >
        </wm-common-button>
        <!-- Submit Confirmation Modal -->
        <wm-common-confirmation-modal
          #submitModal
          [data]="submitModalData"
          (onNoClick)="submitCloseModal()"
          (onYesClick)="submitConfirm()"
          [isApplicantMobileview]="
            context?.janusLayout === 'applicant' ? true : false
          "
          [isApplicantMobileview]="true"
        ></wm-common-confirmation-modal>
        }
        <!-- Added by Amisha on 2026-08-31.
             Reason: provide an accessible arrow control inside the compact Next/Submit action. -->
        <button
          *ngIf="isJanusMobileView && shouldShowNext"
          type="button"
          class="mobile-actions-toggle"
          [class.mobile-actions-toggle-open]="mobileActionsOpen"
          [attr.aria-expanded]="mobileActionsOpen"
          [attr.aria-label]="
            mobileActionsOpen
              ? 'Hide application actions'
              : 'Show application actions'
          "
          (click)="toggleMobileActions($event)"
        >
          <span class="material-icons" aria-hidden="true"
            >keyboard_arrow_up</span
          >
        </button>
      </div>
    </div>
  </div>
</ng-template>
<!-- Added by Amisha on 2026-06-12. -->
<!-- Reason: show the Janus-only confirmation before direct stepper step changes. -->
<wm-common-confirmation-modal
  *ngIf="
    context?.janusLayout === 'staff' || context?.janusLayout === 'applicant'
  "
  [data]="stepNavigationModalData"
  (onNoClick)="cancelStepNavigation()"
  (onYesClick)="confirmStepNavigation()"
  [isApplicantMobileview]="context?.janusLayout === 'applicant' ? true : false"
></wm-common-confirmation-modal>
